import { render } from "./YellowConsultantRegister.vue?vue&type=template&id=0ded37c2"
import script from "./YellowConsultantRegister.vue?vue&type=script&lang=js"
export * from "./YellowConsultantRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__